(function ($, Drupal) {

  "use strict";

  // Add is-active link to menu links.
  // This is a fix for https://www.drupal.org/project/drupal/issues/2652000.
  Drupal.behaviors.fundMenu = {
    attach: function (context, settings) {
      const $fundMenu = $('.fund-menu', context);
      const pathname = location.pathname;

      $fundMenu.find('ul.menu li a').each(function() {
        const $this = $(this);
        if($this.attr('href').indexOf(pathname) !== -1){
          $this.addClass('is-active');
        }
      });
    }
  };

})(jQuery, Drupal);
